import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { YardCard, Loader, Empty } from "@/components/shared";
import { toast } from "sonner";
import { Navigation } from "lucide-react";
import { LocationBar } from "@/components/LocationBar";
import { useLocationCtx } from "@/context/LocationContext";

export default function YardsPage() {
  const [yards, setYards] = useState([]);
  const [cities, setCities] = useState([]);
  const [city, setCity] = useState("");
  const [q, setQ] = useState("");
  const [sort, setSort] = useState("rating");
  const [loading, setLoading] = useState(true);
  const { coords, requestLocation } = useLocationCtx();

  useEffect(() => { api.get("/cities").then(({ data }) => setCities(data)); }, []);

  // Auto-switch to nearest sorting once we have the user's location.
  useEffect(() => { if (coords) setSort("nearest"); }, [coords]);

  useEffect(() => {
    setLoading(true);
    const params = { city: city || undefined, q: q || undefined, sort };
    if (coords) { params.lat = coords.lat; params.lng = coords.lng; }
    api.get("/yards", { params }).then(({ data }) => setYards(data)).finally(() => setLoading(false));
  }, [city, q, sort, coords]);

  const nearest = async () => {
    if (!coords) {
      toast.info("جارٍ تحديد موقعك...");
      const c = await requestLocation();
      if (!c) { toast.error("تعذّر تحديد موقعك. اختر مدينتك بالأسفل."); return; }
    }
    setSort("nearest");
  };

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 py-8">
      <h1 className="font-head text-2xl sm:text-3xl font-black text-white mb-2">التشاليح المعتمدة</h1>
      <p className="text-[var(--text-muted)] mb-4">تصفح التشاليح الموثقة واطلب قطعك مباشرة.</p>
      <div className="mb-4"><LocationBar /></div>
      <div className="ts-card p-4 mb-6 flex flex-col sm:flex-row gap-3">
        <input data-testid="yard-search-input" placeholder="ابحث باسم التشليح" onChange={(e) => setQ(e.target.value)}
          className="flex-1 rounded-xl bg-[var(--bg-secondary)] px-4 py-3 text-white outline-none" />
        <select data-testid="yard-city-filter" value={city} onChange={(e) => setCity(e.target.value)}
          className="rounded-xl bg-[var(--bg-secondary)] px-4 py-3 text-white outline-none">
          <option value="">كل المدن</option>
          {cities.map((c) => <option key={c.id} value={c.name}>{c.name}</option>)}
        </select>
        <select data-testid="yards-sort" value={sort} onChange={(e) => e.target.value === "nearest" ? nearest() : setSort(e.target.value)}
          className="rounded-xl bg-[var(--bg-secondary)] px-4 py-3 text-white outline-none">
          <option value="rating">الأعلى تقييمًا</option>
          <option value="newest">الأحدث</option>
          <option value="nearest">الأقرب لي</option>
        </select>
        <button data-testid="yards-nearest-button" onClick={nearest}
          className={`inline-flex items-center justify-center gap-2 rounded-xl px-4 py-3 text-sm font-bold border ${sort === "nearest" ? "border-[var(--amber)] text-[var(--amber)] bg-[var(--amber)]/10" : "border-[var(--border-c)] text-[var(--text-muted)]"}`}>
          <Navigation size={16} /> الأقرب لي
        </button>
      </div>
      {loading ? <Loader /> : yards.length === 0 ? <Empty text="لا توجد تشاليح مطابقة." /> : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {yards.map((y) => <YardCard key={y.id} yard={y} />)}
        </div>
      )}
    </div>
  );
}
